export default "__VITE_ASSET__Cav3kCNu__"